import * as React from 'react';
import { Button, Checkbox, FormControlLabel, Grid } from '@mui/material/';
import { ManagerProxyDto } from '../../../api';
import Loading from '../../../components/Loading';
import ManagerProxyQueries from './ManagerProxyQueries';
import { getComboBoxOptions } from '../../../utils/Utils';
import useFormStyles from '../../../styles/useFormStyles';
import { ComboBoxOption } from '../../../components/form/controls/ComboBox';
import { useForm, SubmitHandler, NestedValue, FormProvider } from 'react-hook-form';
import { CalendarDatePicker, SelectionBox } from '../../../components/form/react-hook-form-components/';
import { useState } from 'react';

interface IManagerProxyFormInputs {
  managerEmployee: NestedValue<ComboBoxOption> | null;
  proxyEmployee: NestedValue<ComboBoxOption> | null;
  endDate?: Date | null;
}

interface ManagerProxyFormProps {
  onSubmitHandler: (input: ManagerProxyDto) => void;
  onCancelHandler: () => void;
}

function ManagerProxyForm(props: ManagerProxyFormProps) {
  const { onCancelHandler, onSubmitHandler } = props;
  const { FetchReportingEmployees, FetchProxyUserOptions } = ManagerProxyQueries();
  const { data: reportingEmployees, isLoading } = FetchReportingEmployees();
  const [isChecked, setIsChecked] = useState(false);
  const { data: proxyUserOptions, isLoading: isLoadingProxyOptions } = FetchProxyUserOptions();

  const methods = useForm<IManagerProxyFormInputs>({
    defaultValues: { endDate: null },
  });
  const classes = useFormStyles();
  const { handleSubmit } = methods;

  if (isLoading || isLoadingProxyOptions) {
    return <Loading />;
  }
  if (reportingEmployees == null) {
    return <div>No Manger Proxies to Display</div>;
  }

  const handleCheckBoxChange = () => {
    setIsChecked(!isChecked);
  };

  const onSubmit: SubmitHandler<IManagerProxyFormInputs> = data => {
    const values = {
      managerEmployeeId: data.managerEmployee?.value,
      proxyEmployeeId: data.proxyEmployee?.value,
      endDate: data.endDate ? new Date(data.endDate) : null,
    } as ManagerProxyDto;
    onSubmitHandler(values);
  };

  return (
    <FormProvider {...methods}>
      <form id="form" onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={1} width={'45rem'}>
          <Grid item container xs={6} direction="column" spacing={1.5}>
            <Grid item>
              <SelectionBox
                name="managerEmployee"
                label="User"
                options={getComboBoxOptions(reportingEmployees)}
                required
              />
            </Grid>
          </Grid>
          <Grid item container xs={6} direction="column" spacing={1.5}>
            <Grid item>
              <SelectionBox
                name="proxyEmployee"
                label="Proxy User"
                options={getComboBoxOptions(proxyUserOptions)}
                required
              />
            </Grid>
          </Grid>
          <Grid item container xs={6} direction="column" spacing={1.5}>
            <Grid item paddingLeft={'2.5%'}>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={handleCheckBoxChange}
                    checked={isChecked}
                    size="small"
                    sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }}
                  />
                }
                label="Set proxy expiration (optional)"
                labelPlacement="end"
              />
            </Grid>
            {isChecked && (
              <Grid item xs={6}>
                <CalendarDatePicker name={'endDate'} label={'End Date'} proxy={true} />
              </Grid>
            )}
          </Grid>
          <Grid item container direction="row" justifyContent={'end'} spacing={1}>
            <Grid item>
              <Button variant="contained" size="large" className={classes.submitButton} type="submit">
                Create
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" size="large" color="neutral" onClick={onCancelHandler}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  );
}
export default ManagerProxyForm;
